import React, {useState} from 'react';
import './ModalTaskReport.scss';
import DynaModal from "../../../../../Components/Modal/DynaModal";
import DynaSelectBox from "../../../../../Components/A13/DynaView/DynaSelectBox";
import DynaInput from "../../../../../Components/A13/DynaView/DynaInput";
import DynaTextarea from "../../../../../Components/A13/DynaView/DynaTextarea";
import {toast} from "react-toastify";
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";

const ModalTaskReport = ({onClose, data, setRefreshData, refreshData}) => {

  const [sendData, setSendData] = useState({
    taskId: data?.number,
    description: "",
    dependency: "yes",
    delay: "no",
    mentor: "none",
    loop: "yes",
    multiProject: "no",
    percent: data?.percentage
  })

  const modalDataHandler = async () => {

    if (sendData?.percent === "") {
      return toast.error("درصد پیشرفت را وارد کنید")
    }
    if (sendData?.description === "") {
      return toast.error("گزارش را وارد کنید")
    }

    const response = await _axios.post(prefixUrl() + "/customFunctions/?request=taskReportSubmit", sendData)
    if (response?.data?.status) {
      toast.success(response?.data?.message)
      onClose()
      setRefreshData(!refreshData)
    } else {
      toast.error(response?.data?.message)
    }
  }

  return (
    <DynaModal onClose={onClose} className={'ModalTaskReport'}>

      <div className="top-header-modal">
        <h6>گزارش کار</h6>
        <span onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
              fill="white"/>
            <path
              d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
              fill="white"/>
            <path
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
              fill="white"/>
          </svg>
        </span>
      </div>

      <div className={"modal-form"}>
        <DynaSelectBox
          options={[
            {label: "بله", value: "yes"},
            {label: "خیر", value: "no"},
          ]}
          hasFilter={false}
          label={"احتمال تاخیر"}
          className={"solid-dyna-input"}
          value={sendData?.delay}
          onChange={(data) => setSendData({...sendData, delay: data?.value})}/>

        <DynaSelectBox
          options={[
            {label: "بله", value: "yes"},
            {label: "خیر", value: "no"},
          ]}
          hasFilter={false}
          label={"وضعیت لوپ"}
          className={"solid-dyna-input"}
          value={sendData?.loop}
          onChange={(data) => setSendData({...sendData, loop: data?.value})}/>

        <DynaSelectBox
          options={[
            {label: "بله", value: "yes"},
            {label: "خیر", value: "no"},
          ]}
          hasFilter={false}
          label={"وابستگی به شخص دیگر"}
          className={"solid-dyna-input"}
          value={sendData?.dependency}
          onChange={(data) => setSendData({...sendData, dependency: data?.value})}/>

        <DynaSelectBox
          options={[
            {label: "بله", value: "yes"},
            {label: "خیر", value: "no"},
          ]}
          hasFilter={false}
          label={"همزمان روی چند پروژه کار میکنید"}
          className={"solid-dyna-input"}
          value={sendData?.multiProject}
          onChange={(data) => setSendData({...sendData, multiProject: data?.value})}/>

        <DynaSelectBox
          options={[
            {label: "زیاد", value: "high"},
            {label: "متوسط", value: "medium"},
            {label: "کم", value: "low"},
            {label: "ندارد", value: "none"},
          ]}
          hasFilter={false}
          label={"تاثیر منتور"}
          className={"solid-dyna-input"}
          value={sendData?.mentor}
          onChange={(data) => setSendData({...sendData, mentor: data?.value})}/>

        <DynaInput label={"درصد پیشرفت"}
                   name={"percent"}
                   className={"solid-dyna-input"}
                   placeholder={"درصد پیشرفت"}
                   value={sendData?.percent}
                   type={"number"}
                   setDataFromComponent={(data) => {
                     if (!isNaN(data?.percent) && +data?.percent <= 100) {
                       setSendData({...sendData, percent: data?.percent});
                     }
                   }}
        />

        <div style={{gridColumn: "1/-1"}}>
          <DynaTextarea label={"گزارش"}
                        name={"description"}
                        style={{height: '130px'}}
                        className={"solid-dyna-input"}
                        placeholder={"گزارش را وارد کنید"}
                        value={sendData?.description}
                        type={"text"}
                        setDataFromComponent={(data) => {
                          setSendData({...sendData, ...data})
                        }}
          />
        </div>

        <div className={"row-button"}>
          <button className={"button-cansel"}
                  type={"button"}
                  onClick={onClose}>انصراف
          </button>
          <button className={"submit-button"}
                  type={"button"}
                  onClick={modalDataHandler}>ثبت
          </button>
        </div>

      </div>

    </DynaModal>
  );
};

export default ModalTaskReport;